import * as React from "react";
import { Icon } from "@blueprintjs/core";
import classNames from "classnames";

export enum QualityStatus {
  Passed = 1,
  Failed = 2,
  Caution = 3,
  Missing = 4,
}

export const QualityControlWrapper = ({
  children,
  singleColumn = false,
}: {
  children?: React.ReactNode;
  singleColumn?: boolean;
}) => {
  return (
    <div className={"quality-control" + (singleColumn ? " quality-control--single-col" : "")}>
      {children}
    </div>
  );
};

export const QualityControlSection = ({
  header,
  right,
  children,
}: {
  header: React.ReactNode;
  right?: React.ReactNode;
  children?: React.ReactNode;
}) => {
  return (
    <div className="quality-control__section">
      <h2>
        <div className="quality-control__section__header">{header}</div>
        {right ? <div className="quality-control__section__right">{right}</div> : null}
      </h2>
      {children}
    </div>
  );
};

export const QualityControlStatuses = ({ children }: { children?: React.ReactNode }) => {
  return <div className="quality-control__statuses">{children}</div>;
};

export const QualityControlStatusLine = ({
  name,
  status,
  value,
}: {
  name: React.ReactNode;
  status?: QualityStatus;
  value: React.ReactNode;
}) => {
  return (
    <div className="quality-control__line">
      {status ? <QualityTag status={status} /> : null}
      <span className="quality-control__line__name">{name}</span>
      <span className="quality-control__line__result">{value}</span>
    </div>
  );
};

export const QualityTag = ({ status }: { status: QualityStatus }) => {
  const classes = classNames("quality-tag", {
    "quality-tag--passed": status === QualityStatus.Passed,
    "quality-tag--failed": status === QualityStatus.Failed,
    "quality-tag--caution": status === QualityStatus.Caution,
    "quality-tag--missing": status === QualityStatus.Missing,
  });
  return (
    <span className={classes}>
      {statusToTagIcon(status)}
      {statusToTagText(status)}
    </span>
  );
};

function statusToTagText(status: QualityStatus): string {
  switch (status) {
    case QualityStatus.Passed:
      return "Passed";
    case QualityStatus.Failed:
      return "Failed";
    case QualityStatus.Caution:
      return "Caution";
    case QualityStatus.Missing:
      return "Missing";
  }
}

function statusToTagIcon(status: QualityStatus): React.ReactNode {
  switch (status) {
    case QualityStatus.Passed:
      return <Icon icon="tick-circle" />;
    case QualityStatus.Failed:
      return <Icon icon="error" />;
    case QualityStatus.Caution:
      return <Icon icon="warning-sign" />;
    case QualityStatus.Missing:
      return <Icon icon="error" />;
  }
}
